import React, { useState, useEffect } from "react";
import { CardSection } from "cxa-components";
import messages from "components/messagesDescription";
import UpArrow from "../../common/ArrowUp";
import DownArrow from "../../common/ArrowDown";
import PropTypes from "prop-types";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { injectIntl } from "react-intl";

const PointsToConsider = ({ selectedClaim, props, isNarrowScreen }) => {
  const [isOpen, setIsOpen] = useState(!isNarrowScreen);

  const toggleAccordion = e => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setIsOpen(!isNarrowScreen);
  }, [isNarrowScreen]);

  return (
    <CardSection>
      {isNarrowScreen ? (
        <button className="noBgNoBorder" onClick={toggleAccordion}>
          <table>
            <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div>
                    <h3>{props.intl.formatMessage(messages.claims.pointsToConsider)}</h3>
                  </div>
                </td>
                <td>
                  {isOpen ? (
                    <UpArrow width="14px" height="14px" />
                  ) : (
                    <DownArrow width="16px" height="16px" />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </button>
      ) : (
        <div style={{ textAlign: "center" }}>
          <h3>{props.intl.formatMessage(messages.claims.pointsToConsider)}</h3>
        </div>
      )}

      {isOpen && (
        <CardSection>
          <p
            dangerouslySetInnerHTML={{
              __html: props.intl.formatMessage({
                id: selectedClaim.claimInstruction,
                defaultMessage: selectedClaim.claimInstruction,
              }),
            }}
          />
        </CardSection>
      )}
    </CardSection>
  );
};

PointsToConsider.propTypes = {
  selectedClaim: PropTypes.object,
  props: PropTypes.object,
  intl: PropTypes.object,
  isNarrowScreen: PropTypes.bool,
};

export default injectIntl(
  withMatchMediaProps({
    isNarrowScreen: {
      maxWidth: 680,
    },
  })(PointsToConsider)
);



// WEBPACK FOOTER //
// ./components/claim/widgets/PointsToConsider.js